import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { Customer } from 'src/features/customers/utils/types';

const RESOURCE = '/customers/customer/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    external_customer_id?: string;
    stripe_customer_id?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Customer>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_CUSTOMERS_RESOURCE, useQueryHook as useListCustomers };
